// ─── SunuChat Design Tokens ───────────────────────────────────────────────────
// Direction : "Editorial Clean" — lisible, humain, confiant

export const PRIMARY_COLOR    = "#0098c0"; // Bleu ciel — confiance, santé
export const SECONDARY_COLOR  = "#a4cb2e"; // Vert lime — vie, accessibilité
export const ACCENT_HOVER     = "#007da3"; // Bleu plus profond pour les hovers

export const BG_PAGE          = "#f9f9f9";
export const BG_WHITE         = "#ffffff";
export const BG_SECTION_ALT   = "#f2f8fb"; // Très légère teinte bleue
export const FOOTER_BG        = "#D8EBE4";

export const TEXT_PRIMARY     = "#1a1a1a";
export const TEXT_SECONDARY   = "#4f4f4f";
export const TEXT_MUTED       = "#999999";
export const TEXT_ON_PRIMARY  = "#ffffff";

export const BORDER_COLOR     = "#e8e8e8";
export const SHADOW_SUBTLE    = "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)";
export const SHADOW_CARD      = "0 2px 8px rgba(0,152,192,0.06), 0 1px 3px rgba(0,0,0,0.05)";
export const SHADOW_CARD_HOVER= "0 8px 32px rgba(0,152,192,0.12), 0 2px 8px rgba(0,0,0,0.06)";

// Fonts — Google Fonts à charger dans index.html :
// <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap" rel="stylesheet">
export const FONT_SANS        = "'Plus Jakarta Sans', sans-serif";
export const FONT_SERIF       = "'Lora', serif"; // Pour les titres principaux seulement